import React from "react";
import { graphql } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import Seo from "@qlik/qlik/src/components/Seo";
import { renderLinkedComponents } from "@qlik/qlik/src/components/registry";
import GatedContent from "@qlik/qlik/src/components/CardDeckContainer/Gated_Content";
import ResourceTemplate from "@qlik/qlik/src/components/InnerPages/Resource";
import { getGatedContentComponent } from "@qlik/qlik/src/lib/util/helpers";
import { useLocation } from "@reach/router";
import { normalizePath } from "@qlik/utils/normalizePathOrUrl";
import {
    RESOURCE_GATED_CONTENT_RENDERING_NAME,
    RESOURCE_GATED_SUCCESS_PAGE_PATHNAME,
    RESOURCE_PATHNAME,
} from "@qlik/qlik/src/lib/constants/resource-constants";

/**
 * GraphQL query to retrieve all data for the flexible page.
 * Gatsby only allows one dynamic query per page.
 */
export const query = graphql`
    query($id: String, $headerName: String, $locale: String) {
        contentfulHeader(name: { eq: $headerName }, node_locale: { eq: $locale }) {
            ...Header
        }
        contentfulResource(id: { eq: $id }) {
            ...Resource
        }
        contentfulFooter(name: { eq: "Full footer" }, node_locale: { eq: $locale }) {
            ...Footer
        }
        contentfulThemeSettings(node_locale: { eq: $locale }) {
            ...ThemeSettings
        }
    }
`;

/**
 * Conditionally renders Gated or Ungated Resources.
 * @param {Object} data - The data object returned from the GraphQL query
 * @returns {JSX.Element} - The rendered Resource component
 */
const Resource = ({ data }) => {
    const { slug, title, components = [] } = data?.contentfulResource ?? {};
    const gatedContent = getGatedContentComponent(data.contentfulResource);
    const { resourceMicrocopyGroup } = data?.contentfulThemeSettings || {};
    const location = useLocation();

    // if ungated - render resource inner
    const bodyContent = gatedContent ? (
        <GatedContent
            data={{ ...gatedContent, title, microcopyGroup: resourceMicrocopyGroup }}
            successUrl={normalizePath(location.pathname + "/" + RESOURCE_GATED_SUCCESS_PAGE_PATHNAME)}
        />
    ) : (
        <ResourceTemplate data={data.contentfulResource} />
    );

    // render components without form component
    const pageComponents = components
        ?.filter((component) => component.frontEndComponent !== RESOURCE_GATED_CONTENT_RENDERING_NAME)
        .map((el, i) => renderLinkedComponents(el, i));

    return (
        <Layout
            headerData={data.contentfulHeader}
            minimalHeaderData={data.contentfulThemeSettings?.minimalNavPages}
            footerData={data.contentfulFooter}
            pageSlug={slug}
            dynamicHeaderCta={data.contentfulThemeSettings?.dynamicHeaderCta}
            searchPopupData={data.contentfulThemeSettings?.searchPopupMicrocopyGroup}
        >
            <Seo
                data={data.contentfulResource.metadata}
                pageSlug={`${RESOURCE_PATHNAME}${slug?.startsWith("/") ? "" : "/"}${slug}`}
            />
            {bodyContent}
            {pageComponents}
        </Layout>
    );
};
export default Resource;
